// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"fea6defc","453":"8ab44547","722":"3ebf3c9b"}[chunkId] + ".chunk.js";
};